import { observer } from 'mobx-react';
import { learningCollectionsStore } from '../../../../../../../stores/LearningCollectionsStore';
import { CardSection } from '../../../../LearningSkeleton';
import DefaultSection from './DefaultSection';
import RecommendedSection from './RecommendedSection';
import PreviewError from '../../PreviewError';

function Details() {
  const store = learningCollectionsStore;
  switch (store.state.kind) {
    case 'errored':
      return <PreviewError />;
    case 'loading':
      return <CardSection />;
    case 'ready':
      const allExperiences = store.state.data.resource.payload.experiences;

      return (
        <div className="flex flex-col gap-y-8">
          <RecommendedSection experiencesArray={allExperiences} />
          <div className="flex flex-grow flex-col gap-y-8">
            <div className="bg-white shadow-section">
              <DefaultSection experiencesArray={allExperiences} />
            </div>
          </div>
        </div>
      );
  }
}

export default observer(Details);
